import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=6c86671e&scoped=true"
import script from "./chat.js?vue&type=script&lang=js&external"
export * from "./chat.js?vue&type=script&lang=js&external"
import style0 from "./chat.scss?vue&type=style&index=0&id=6c86671e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c86671e",
  null
  
)

export default component.exports